import axios from 'axios'
import { Message } from 'element-ui'
// 1.创建axios实例
const instance = axios.create({
  // timeout: 1000000
  // headers: { 'Access-Control-Allow-Origin': '*' }
})
// axios.defaults.withCredentials = true
const judge = url => {
  if (
    url.indexOf('/web') !== -1 ||
    url.indexOf('/virusdb') !== -1 ||
    url.indexOf('/base') !== -1 ||
    url.indexOf('/storage') !== -1
  ) {
    return true
  } else {
    return false
  }
}
// 2.导出get、post方法
export default {
  get (url, params = {}, success) {
    return new Promise(() => {
      instance({
        url,
        method: 'get',
        params: params,
        baseURL: judge(url) ? '/' : '/algae'
      })
        .then(res => {
          success(res.data)
          // console.log(res.data.data);
        })
        .catch(err => {
          console.log(err)
          // Message.error(err)
        })
    })
  },

  post (url, params, success, options = {}) {
    return new Promise(() => {
      instance({
        url,
        method: 'post',
        data: params,
        baseURL: judge(url) ? '/' : '/algae',
        ...options
      })
        .then(res => {
          success(res.data)
        })
        .catch(err => {
          Message.error(err)
          // console.log(err)
        })
    })
  },

  postGetZip (url, params, success) {
    return new Promise(() => {
      instance({
        url,
        method: 'post',
        data: params,
        baseURL: judge(url) ? '/' : '/algae',
        responseType: 'blob'
      })
        .then(res => {
          success(res.data)
        })
        .catch(err => {
          Message.error(err)
          // console.log(err)
        })
    })
  },

  postGetId (url, params = [], success) {
    return new Promise(() => {
      instance({
        url,
        method: 'post',
        data: params,
        baseURL: judge(url) ? '/' : '/algae'
      })
        .then(res => {
          success(res.data)
        })
        .catch(err => {
          Message.error(err)
          // console.log(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js